export const ROUTE_JOB_PLACEMENT = 'job-placement';
export const ROUTE_COMPANIES = 'companies';
export const ROUTE_BLOG = 'blog';
export const ROUTE_CREATE_BLOG = 'create-blog';
export const ROUTE_USER_FORMS = 'user-forms';
export const LOGIN = 'login';
